import React from 'react';
import styled from '@emotion/styled';

const ActivityList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

const ActivityItem = styled.div`
  font-size: 0.75rem;
  color: #6b7280;
  padding: 0.5rem;
  background: #f8fafc;
  border-radius: 4px;
  border-left: 3px solid #3b82f6;
`;

const SectionDivider = styled.div`
  height: 1px;
  background: #666;
  margin: 1.5rem 0;
  opacity: 0.8;
`;

const SectionTitle = styled.h3`
  font-size: 0.875rem;
  font-weight: 600;
  color: #f0f0f0;
  margin: 0 0 0.75rem 0;
`;

const ActivityContent = () => {
  return (
    <>
      <ActivityList>
        <ActivityItem>Loan 1048000010 processed • 2 minutes ago</ActivityItem>
        <ActivityItem>22 fields extracted from Master document • 5 minutes ago</ActivityItem>
        <ActivityItem>Security Agreement uploaded • 15 minutes ago</ActivityItem>
        <ActivityItem>Proposal form analyzed • 1 hour ago</ActivityItem>
        <ActivityItem>Note document OCR completed • 2 hours ago</ActivityItem>
        <ActivityItem>Quality check passed • 3 hours ago</ActivityItem>
        <ActivityItem>Database backup completed • 1 day ago</ActivityItem>
        <ActivityItem>System maintenance completed • 2 days ago</ActivityItem>
      </ActivityList>
      
      <SectionDivider />
      
      <SectionTitle>System Status</SectionTitle>
      <ActivityList>
        <ActivityItem>All services operational</ActivityItem>
        <ActivityItem>Database connection: Active</ActivityItem>
        <ActivityItem>OCR processing: Available</ActivityItem>
        <ActivityItem>Last sync: 2 minutes ago</ActivityItem>
      </ActivityList>
    </>
  );
};

export default ActivityContent;
